const e=e=>Boolean(document.querySelector(`script[src="${e}"]`));export{e as isScriptAlreadyAdded};
//# sourceMappingURL=isScriptAlreadyAdded.js.map
